<div class="view-wrapper">
  @if (localImageSrc) {
    <ev-image-viewer
      #imageViewer
      class="image-viewer"
      [src]="localImageSrc"
      [config]="imageViewerTopConfigs"
      (viewerError)="onViewerError($event)"
      (initialized)="onImageLoaded()"
    />
  } @else {
    <div class="image-viewer"></div>
  }

  <div class="threeD-viewer-wrapper">
    <ev-threejs-viewer #threeDViewer [config]="threejsViewerConfig" (viewerError)="onViewerError($event)" />

    @if (isLoading3DModel()) {
      <evc-loading-spinner class="spinner" />
    }

    @if (error()) {
      <div class="error-message">
        {{ error() | translate }}
      </div>
    }
  </div>

  <div class="measurement-results-wrapper">
    <app-measurement-picker class="measurement-picker" [disabled]="isLoading3DModel() || !!error()" />
    <app-measurement-results />
  </div>
</div>
